import * as React from "react";
import { Fun, IOWidget, mk_widget } from "../widget";

export interface Branch<i,o> {
  condition:Fun<i,boolean>
  widget:IOWidget<i,o>
}

interface ChoiceProps<i,o> {
  input:i
  branches:Branch<i,o>[]
  on_done:(output:o) => void
}

interface ChoiceState<_i,_o> { }

/** @deprecated Don't use directly, use the [[choice]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
*/
class Choice<i,o> extends React.Component<ChoiceProps<i,o>, ChoiceState<i,o>> {
  constructor(props:ChoiceProps<i,o>, context:any) {
    super(props, context)
  }

  render() {
    return this.props.branches.map(branch =>
      branch.condition(this.props.input) ? branch.widget(this.props.input).run(output => this.props.on_done(output))
      : null)
  }
}

export const choice = function<i,o>(branches:Branch<i,o>[]) :
  IOWidget<i,o> {
  return (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<ChoiceProps<i,o>>(Choice, { branches, input, on_done })
  })
}
